import {
	confirmImportProductsError,
	confirmImportProductsSuccess,
	importProductsError,
	importProductsPaginationSuccess,
	importProductsSuccess
} from 'actions'
import {
	confirmImportProductsApi,
	importProductsApi,
	importProductsPaginationApi
} from 'api/ProductImport'
import { ProductImportActions } from 'constants/ActionsTypesTs'
import {
	IConfirmImportProductsAction,
	ImportProductsAction,
	IPaginationImportProductTableAction
} from 'models/ProductImport'
import { all, call, fork, put, takeLatest } from 'redux-saga/effects'

function* importProductsRequest({ payload }: ImportProductsAction): any {
	try {
		const products: any = yield call(importProductsApi, payload)
		yield put(importProductsSuccess(products))
	} catch (error: any) {
		const { Resultado } = error.response.data
		const messageError = Resultado.Mens_error || ''
		yield put(
			importProductsError({
				messageError,
				error: ProductImportActions.IMPORT_PRODUCTS_ERROR
			})
		)
	}
}

function* confirmImportProductsRequest({
	payload
}: IConfirmImportProductsAction): any {
	try {
		const products: any = yield call(confirmImportProductsApi, payload)
		yield put(confirmImportProductsSuccess(products))
	} catch (error: any) {
		const { Resultado, Mens_error } = error.response.data

		const messageError = Resultado.Mens_error ?? Mens_error ?? ''
		yield put(
			confirmImportProductsError({
				messageError,
				error: ProductImportActions.CONFIRM_IMPORT_PRODUCTS_ERROR
			})
		)
	}
}

function* importProductsPaginationRequest({
	payload
}: IPaginationImportProductTableAction): any {
	try {
		const products: any = yield call(importProductsPaginationApi, payload)
		yield put(importProductsPaginationSuccess(products))
	} catch (error: any) {}
}

export function* importProductsSaga() {
	yield takeLatest(ProductImportActions.IMPORT_PRODUCTS, importProductsRequest)
}

export function* confirmImportProductsSaga() {
	yield takeLatest(
		ProductImportActions.CONFIRM_IMPORT_PRODUCTS,
		confirmImportProductsRequest
	)
}

export function* importProductsPaginationSaga() {
	yield takeLatest(
		ProductImportActions.IMPORT_PRODUCTS_TABLE_PAGINATION,
		importProductsPaginationRequest
	)
}

export default function* rootSaga() {
	yield all([
		fork(importProductsSaga),
		fork(confirmImportProductsSaga),
		fork(importProductsPaginationSaga)
	])
}
